import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import ProductTranslation from '@/repositories/data/webshop/ProductTranslation';
import HttpClient from '@/util/http/HttpClient';

export default class ProductTranslationRepository extends BaseCrudRepository<
    number,
    ProductTranslation,
    ProductTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product-translation/');
    }
}
